// src/pages/Pinterest.js
import React from 'react';
import FeaturePageLayout from '../components/FeaturePageLayout';
import { 
    IoLogoPinterest,
    IoColorPaletteOutline,
    IoCalendarOutline,
    IoAnalyticsOutline,
    IoLinkOutline
} from 'react-icons/io5';
import image1 from '../assets/images/Generate.png';
import image2 from '../assets/images/Schedule2.png';
import image3 from '../assets/images/Messages.png';
import image4 from '../assets/images/Analytics2.png';
import heroBg from '../assets/images/pinterest-background.png';

const breadcrumbSchema = { "@context": "https://schema.org", "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://oolook.in/" }, { "@type": "ListItem", "position": 2, "name": "Pinterest Management", "item": "https://oolook.in/pinterest" }] };
const serviceSchema = { "@context": "https://schema.org", "@type": "Service", "serviceType": "Pinterest Marketing Software", "provider": { "@type": "Organization", "name": "Oolook" }, "name": "AI Pinterest Management Tool", "description": "Drive discovery and traffic with Oolook's AI-powered Pinterest tools. Generate beautiful Pins, schedule them to your boards, and track what drives clicks.", "url": "https://oolook.in/pinterest" };

const pageData = {
  seo: {
    title: "AI Pinterest Management & Scheduling Tool | Oolook",
    description: "Supercharge your Pinterest strategy. Use Oolook's AI to design and schedule stunning Pins, manage your boards, and analyze the traffic driven to your website.",
    image: 'https://oolook.in/og/pinterest.png',
    schemas: [breadcrumbSchema, serviceSchema]
  },
  hero: {
    icon: IoLogoPinterest,
    title: "Capture Inspiration, Drive Action",
    subtitle: "Turn Pinterest from a mood board into a powerful traffic driver. Oolook helps you create, schedule, and analyze beautiful Pins that get discovered and clicked.",
    backgroundImage: heroBg
  },
  featureSection: {
    title: "Your Complete Pinterest Workflow, Simplified",
    subtitle: "From Pin creation to performance analysis, manage your entire Pinterest strategy in one place.",
    features: [
      { title: "AI Pin Idea Generator", description: "Never run out of ideas. Our AI suggests trending topics and visually compelling concepts for your next Pin and board.", image: image1 },
      { title: "Smart Pin Scheduler", description: "Schedule Pins to multiple boards at the optimal times for engagement. Plan your content weeks or months in advance.", image: image2 },
      { title: "Unified Comment Management", description: "Keep track of all the comments on your Pins from our Unified Inbox, helping you engage with your community.", image: image3 },
      { title: "Track Clicks & Website Traffic", description: "Our analytics focus on what matters for Pinterest: outbound clicks, saves, and the traffic being driven to your site.", image: image4 }
    ]
  },
  benefitGrid: {
    title: "The Value of a Visual Strategy",
    benefits: [
      { icon: IoColorPaletteOutline, title: "Create Stunning Visuals", description: "Use AI assistance to create Pins that are optimized to capture attention and inspire action." },
      { icon: IoLinkOutline, title: "Drive Website Traffic", description: "Focus your strategy on creating content that turns browsers into website visitors and customers." },
      { icon: IoCalendarOutline, title: "Maintain Consistency", description: "Keep your boards fresh and active with our effortless scheduling tools, boosting your visibility." },
      { icon: IoAnalyticsOutline, title: "Measure What Matters", description: "Go beyond vanity metrics and understand exactly how Pinterest is contributing to your business goals." }
    ]
  },
  stepByStep: {
    title: "Launch Your Pinterest Strategy",
    subtitle: "A simple workflow for driving discovery and traffic.",
    steps: [
      { title: "1. Connect Your Pinterest Account", description: "Link your Pinterest profile to sync your boards and unlock scheduling and analytics features." },
      { title: "2. Generate Pin Ideas", description: "Use the AI generator to create a list of content ideas and visually appealing concepts for your brand." },
      { title: "3. Schedule Your Pins", description: "Upload your Pin creatives and use Oolook to schedule them to your chosen boards at the best times." },
      { title: "4. Analyze Your Traffic", description: "Monitor your analytics to see which Pins are driving the most saves and outbound clicks to your website." }
    ]
  },
  targetAudience: {
    title: "The Essential Tool for E-commerce, Bloggers, and Creatives"
  }
};

const Pinterest = () => {
  return <FeaturePageLayout pageData={pageData} />;
};

export default Pinterest;